import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { Category } from "@app/types/index";

export type CategoryMenuProps = {
  categories: Category[];
  onCategorySelect: (categoryId: number) => void;
};

export const CategoryMenu = defineComponent<CategoryMenuProps>({
  name: "CategoryMenu",
  props: ["categories", "onCategorySelect"],
  setup(props) {
    const showDropdown = ref(false);
    const dropdownRef = ref<HTMLDivElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.value &&
        !dropdownRef.value.contains(event.target as Node)
      ) {
        showDropdown.value = false;
      }
    };

    const scrollToCategory = (categoryId: number) => {
      props.onCategorySelect(categoryId);
      showDropdown.value = false;
    };

    onMounted(() => {
      document.addEventListener("mousedown", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("mousedown", handleClickOutside);
    });

    return () => (
      <div class="relative" ref={dropdownRef}>
        <button
          onClick={() => (showDropdown.value = !showDropdown.value)}
          class="px-2 flex justify-center items-center"
        >
          <span class="material-symbols-outlined text-2xl">list</span>
        </button>

        {showDropdown.value && (
          <div class="absolute top-full left-2 z-50 bg-base-100 border border-base-300 rounded-lg shadow-lg min-w-48 max-h-96 overflow-y-auto">
            {props.categories.map((category) => (
              <button
                key={category.id}
                onClick={() => scrollToCategory(category.id)}
                class="w-full text-left px-4 py-2 hover:bg-base-200 first:rounded-t-lg last:rounded-b-lg"
              >
                {category.name}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  },
});
